import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import history from '../../history';
import { messages } from './HealthSummary.i18n';
import { healthSummaryListLoaded, updateHealthSummaryIdentifier }
  from '../../redux/modules/health-summary/actions/creators';


function CcdaList({ filteredCcdas }) {
  const dispatch = useDispatch();
  const getLabel = (id) => 'label_' + id;

  const viewCcda = (ccdaIdentifier) => (e) => {
    e.preventDefault();

    if (ccdaIdentifier) {
      dispatch(healthSummaryListLoaded([]));
      dispatch(updateHealthSummaryIdentifier(ccdaIdentifier));
    }
  }

  const cancelViewingCcda = () => {
    history.push('/');
  }

  return (
    <div>
      <p><FormattedMessage {...messages.datelist.title} /></p>
      <div className="row">
        <div className="col-sm-4">
          <table className="table" data-qa-container="HealthSummaryDates">
            <thead>
              <tr>
                <th colSpan={2}><FormattedMessage {...messages.datelist.tableheader} /></th>
              </tr>
            </thead>
            <tbody>
              { filteredCcdas.map((ccda, idxkey) => (
                  <tr key={idxkey}>
                    <td>
                      <span id={getLabel(idxkey)}>
                        { moment(ccda.displayDate).format('ll') }
                      </span>
                    </td>
                    <td>
                      <a
                        style={{ cursor: 'pointer' }}
                        tabIndex="0"
                        onClick={ viewCcda(ccda) }
                        aria-describedby={getLabel(idxkey) + ' ccdalabel'}
                        role="button"
                        href="#"
                      >
                        <FormattedMessage {...messages.datelist.viewlabel} />
                      </a>
                    </td>
                  </tr>
              ))}
            </tbody>
          </table>
          <a className="btn btn-link" type="button" onClick={ cancelViewingCcda } role="button" tabIndex="0">
            <FormattedMessage {...messages.datelist.cancellabel} />
          </a>
        </div>
      </div>
      <span id="ccdalabel" className="sr-only" >
        <FormattedMessage {...messages.page.ccdaLabel} />
      </span>
    </div>
  );
}

CcdaList.propTypes = {
  filteredCcdas: PropTypes.array,
};

export default CcdaList;